import { inject } from '@angular/core';
import { ProgramsService } from './programs.service';
import { ResolveFn } from '@angular/router';

export const programTypesResolver: ResolveFn<void> = async () => {
  await inject(ProgramsService).getProgramTypes();
}

